import * as React from 'react';

function useThrottledEffect(
  callback: Function,
  dependencies: Array<any>,
  throttleBy: number = 100
) {
  const callbackRef = React.useRef(callback);
  callbackRef.current = callback;

  const lastRun = React.useRef<number | null>(null);

  React.useEffect(() => {
    // For the very first time, we want to run the callback immediately
    if (lastRun.current === null) {
      lastRun.current = Date.now();
      callbackRef.current();
      return;
    }

    const elapsed = Date.now() - lastRun.current;

    if (elapsed > throttleBy) {
      lastRun.current = Date.now();
      callbackRef.current();
    } else {
      const timeout = setTimeout(() => {
        lastRun.current = Date.now();
        callbackRef.current();
      }, throttleBy - elapsed);

      return () => {
        clearTimeout(timeout);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}

export default useThrottledEffect;
